/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/no-duplicate-string */

/*
 * Disabled the following rules:
 * @typescript-eslint/naming-convention
 * @typescript-eslint/no-empty-interface
 * @typescript-eslint/no-unused-vars
 * sonarjs/no-duplicate-string
 * as MUI theme override required override interfaces.
 * Also, it has no sense to move out css variables into another variable
 *
 * More details on style overrides here https://mui.com/material-ui/customization/theme-components/#default-props
 */
import {ThemeOptions} from "@mui/material/styles";
import {buttonClasses} from "@mui/material";

export const buttonsTheme: ThemeOptions = {
	components: {
		MuiButton: {
			defaultProps: {
				disableElevation: true,
			},
			styleOverrides: {
				root: {
					fontWeight: "700",
					fontSize: "16px",
					borderRadius: "100px",
					height: "48px",
					paddingLeft: "20px",
					paddingRight: "20px",
					color: "var(--textDark)",
					":hover": {
						":disabled": {
							boxShadow:
								"0px 0.1px 0.3px rgba(28, 28, 30, 0.1), 0px 1px 2px rgba(28, 28, 30, 0.2)",
						},
					},
					[`&.${buttonClasses.contained}`]: {
						[`&.${buttonClasses.colorSecondary}`]: {
							":hover": {
								background: "#FFF",
							},
							"&:disabled": {
								background: "#62676E",
								color: "#D9DEE4",
								cursor: "default",
							},
						},
						[`&.${buttonClasses.colorPrimary}`]: {
							"&:disabled": {
								background: "#62676E",
								color: "#D9DEE4",
								cursor: "default",
							},
						},
						[`&.${buttonClasses.colorError}`]: {
							background: "red",
							color: "#FFF",
						},
						[`&.${buttonClasses.colorInfo}`]: {
							":disabled": {
								background: "#FFF",
								color: "var(--textDark)",
								":hover": {
									background: "#FFF",
									color: "var(--textDark)",
								},
							},
						},
					},
					[`&.${buttonClasses.outlined}`]: {
						[`&.${buttonClasses.colorPrimary}`]: {
							borderColor: "var(--primaryColor)",
							color: "var(--primaryColor)",
							":hover": {
								borderColor: "blue",
							},
						},
						[`&.${buttonClasses.colorSecondary}`]: {
							borderColor: "var(--secondaryColor)",
							color: "var(--secondaryColor)",
						},
					},
					[`&.${buttonClasses.text}`]: {
						color: "#fff",
						padding: "8px",
						height: "auto",
						lineHeight: 1,
						borderWidth: "0",
						textTransform: "none",
						[`&.${buttonClasses.colorSecondary}`]: {
							color: "var(--secondaryColor)",
							textDecoration: "underline",
							textUnderlineOffset: "2px",
						},

						[`&.${buttonClasses.colorInherit}`]: {
							color: "currentColor",
						},

						".border": {
							borderBottom: "1px solid currentColor",
						},
					},
				},
			},
			variants: [
				{
					props: {className: "byClassName"},
					style: {
						background: "yellow",
						color: "#000",
						":hover": {
							background: "blue",
						},
					},
				},
			],
		},
	},
};
